export default {
      id: "_2808612491392-usage",
      viewBox: "0 0 33 35",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#_2808612491392",
      toString: function () {
        return this.url;
      }
    }